import React from 'react';

import { faShoppingCart } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

import AutocompleteSearch from '../components/AutocompleteSearch';

export default {
  name: 'ventes',
  title: 'Ventes',
  icon: faShoppingCart,
  resource: 'vente',
  primaryKey: 'idvente',
  query: {
    _associations: 'conseiller,entiteclient,lot',
    'lot._associations': 'prog',
    'lot.prog._associations': 'promoteur',
  },
  sort: '-idvente',
  head: {
    idindividu: 'Commercial',
    client: 'Client',
    lot: 'Lot',
    programme: 'Programme',
    promoteur: 'Promoteur',
    px_pierre: 'Prix',
    date_avancement_dossier: 'Date Maj',
    avancement_dossier: 'Stade',
  },
  list: ({ values, props }) => [
    values.conseiller ? values.conseiller?.nom + ' ' + values.conseiller?.prenom : '',
    values.entiteclient ? values.entiteclient?.nom?.toUpperCase() : '',
    <Link to={{ pathname: `/i9/lots/${values.lot?.id}` }}>{values.lot?.ref}</Link>,
    <Link to={{ pathname: `/i9/programmes/${values.lot?.prog?.id}` }}>{values.lot?.prog?.nom}</Link>,
    <Link to={{ pathname: `/i9/promoteurs/${values.lot?.prog?.promoteur?.idpromoteur}` }}>
      {values.lot?.prog?.promoteur?.nom}
    </Link>,
    values.px_pierre,
    values.date_avancement_dossier,
    values.avancement_dossier,
  ],
  filter: ({ values, props, setFieldValue, handleSubmit }) => [
    <AutocompleteSearch
      {...props}
      fullWidth
      resource='individu'
      optionLabel={option => option.nom + ' ' + option.prenom}
      attribute='nom'
      filters={{ conseiller: 1 }}
      label='Commercial'
      onChange={(event, value) => {
        setFieldValue('idindividu', value?.idindividu);
        handleSubmit();
      }}
    />,
    <AutocompleteSearch
      {...props}
      fullWidth
      resource='entite_cliente'
      optionLabel={option => `${option.nom} ${option.client?.prenom}`}
      associations='client'
      filters={{ _fields: 'nom,identite', 'individu._fields': 'prenom' }}
      attribute='nom'
      label='Nom client'
      onChange={(event, value) => {
        setFieldValue("['identiteclient']", value?.identite);
        handleSubmit();
      }}
    />,
  ],
  add: true,
  show: true,
  remove: true,
};
